// TODO поправить типизацию в файле
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '@ui-lib/components';

@Injectable()
export class ExceptionInterceptor implements HttpInterceptor {
  private readonly internalServerErrorLocalizationKey =
    'server-errors.internal-server-error';

  constructor(
    private readonly router: Router,
    private readonly toastService: ToastService,
  ) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        switch (error.status) {
          case 404:
            this.router.navigate(['404'], { replaceUrl: true });
            return EMPTY;
          case 500:
            this.toastService.error({
              message: this.internalServerErrorLocalizationKey,
            });
            return EMPTY;
        }

        return throwError(() => error);
      }),
    );
  }
}
